import { getMenuIsLoaded } from 'selectors/menu-metadata/getMenuIsLoaded'

import { fetchData } from './fetchData'

export const loadMenuServiceDataIfDeepLinked =
  (isSignUpPage, addRecipe) => async (dispatch, getState) => {
    const menuIsLoaded = getMenuIsLoaded(getState())

    if (!menuIsLoaded) {
      await dispatch(fetchData({ query: {}, params: {} }, false, true, { addRecipe }))
    }
  }
